import { service } from '../utils';

export const linkRobot = appId => {
    return service.get(`/smart/1.0/edi/config?appId=${appId}`);
};
